var exports = {
  "k": "x127c5a35--205a93--container",
};

module.exports = exports;
